import { AxiosInstance } from 'axios';

import { axios } from '../../../../api/axios-instance';
import { scheduleEndpoints } from '../../../../constants';
import { SortRequest } from '../../../../types/sort-request';
import {
  EmployeesSchedule,
  EmployeesScheduleFilter,
  ScheduleTemplateResponse,
} from '../../../requests/schedule.schema';
import { IProfile } from '../../../user/entities/profile';

export class ScheduleApi {
  #requestInstance: AxiosInstance;

  constructor(requestInstance: AxiosInstance) {
    this.#requestInstance = requestInstance;
  }

  getEmployeesSchedule = async (
    data?: EmployeesScheduleFilter & SortRequest<keyof IProfile>
  ): Promise<EmployeesSchedule[]> => {
    return this.#requestInstance.get(scheduleEndpoints.getEmployeesSchedule, { params: data });
  };

  getEmployeesCount = async (): Promise<number> => {
    return this.#requestInstance.get(scheduleEndpoints.getUsersCount);
  };

  getScheduleTemplate = async (year: number): Promise<ScheduleTemplateResponse> => {
    return this.#requestInstance.get(scheduleEndpoints.getCompanyScheduleTemplate(year));
  };
}

export const scheduleApi = new ScheduleApi(axios);
